// extracted by mini-css-extract-plugin
export default {"wrapper":"ModalAddCollection_wrapper__12prQ","head":"ModalAddCollection_head__czaJi","content":"ModalAddCollection_content__vlaFu"};